import React, { Component } from "react";

import { Form } from "components";
class Filters extends Component {

  handleClean = async (e) => {
    const { onClean } = this.props;

    onClean(e);
  }

  render() {
    const { data, onChange } = this.props;

    return (
      <Form className="row form-filters margin-top-40">
        <h3 className="margin-left-20">Analítico</h3>

        <Form.Field className="col-md-5">
          <Form.Label>Período, de</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={data.date_start}
              onChange={value => onChange('date_start', value)}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="col-md-5">
          <Form.Label>Período, até</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={data.date_end}
              onChange={value => onChange('date_end', value)}
              minDate={data.date_start}
              disabled={data.date_start === null}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Button className="button-clean-filter" onClick={(e) => this.handleClean(e)}>
            Resetar Filtro
          </Form.Button>
        </Form.Field>
      </Form>
    );
  }
}

export default Filters;
